module.exports = __webpack_public_path__ + "img/logo-white-full-hat.83bb9e1.png";